// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     // this.addEventListener('click', (event) => {
//     //   event.preventDefault();
//     //   const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
//     //   cartItems.updateQuantity(this.dataset.index, 0);
//     // });
//     this.addEventListener('click', (event) => {
//       event.preventDefault();

//       const cartItem = this.closest('.cart-item');
//       const bundleKeyFromDom  = cartItem?.dataset?.bundleKey;

//       const cartItems =
//         this.closest('cart-items') || this.closest('cart-drawer-items');

//        if (bundleKeyFromDom) {
//         cartItems.removeBundleByKey(bundleKeyFromDom);
//       } else {
//         // Normal single item remove
//         cartItems.updateQuantity(this.dataset.index, 0);
//       }
//     });
//   }
// }

// customElements.define('cart-remove-button', CartRemoveButton);

// class CartItems extends HTMLElement {
//   constructor() {
//     super();
//     this.lineItemStatusElement =
//       document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

//     const debouncedOnChange = debounce((event) => {
//       this.onChange(event);
//     }, ON_CHANGE_DEBOUNCE_TIMER);

//     this.addEventListener('change', debouncedOnChange.bind(this));
//   }

//   cartUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
//       if (event.source === 'cart-items') {
//         return;
//       }
//       this.onCartUpdate();
//     });
//   }

//   disconnectedCallback() {
//     if (this.cartUpdateUnsubscriber) {
//       this.cartUpdateUnsubscriber();
//     }
//   }

//   onChange(event) {
//     this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
//   }

//   onCartUpdate() {
//     if (this.tagName === 'CART-DRAWER-ITEMS') {
//       fetch(`${routes.cart_url}?section_id=cart-drawer`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');
//           const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
//           for (const selector of selectors) {
//             const targetElement = document.querySelector(selector);
//             const sourceElement = html.querySelector(selector);
//             if (targetElement && sourceElement) {
//               targetElement.replaceWith(sourceElement);
//             }
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         });
//     } else {
//       fetch(`${routes.cart_url}?section_id=main-cart-items`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');
//           const sourceQty = html.querySelector('cart-items');
//           this.innerHTML = sourceQty.innerHTML;
//         })
//         .catch((e) => {
//           console.error(e);
//         });
//     }
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'main-cart-items',
//         section: document.getElementById('main-cart-items').dataset.id,
//         selector: '.js-contents',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//       {
//         id: 'cart-live-region-text',
//         section: 'cart-live-region-text',
//         selector: '.shopify-section',
//       },
//       {
//         id: 'main-cart-footer',
//         section: document.getElementById('main-cart-footer').dataset.id,
//         selector: '.js-contents',
//       },
//     ];
//   }

// // ==================================================================
// // ==================================================================  

// // async removeBundleByKey(bundleKey) {
// //   try {
// //     // 1️⃣ Fetch actual cart
// //     const cart = await fetch('/cart.js').then(r => r.json());

// //     // 2️⃣ Prepare updates using Shopify line numbers
// //     const updates = {};
// //     cart.items.forEach((item, index) => {
// //       if (item.properties?._bundle_link_key === bundleKey) {
// //         updates[item.key] = 0; // item.key = Shopify’s unique cart item key
// //       }
// //     });

// //     if (Object.keys(updates).length === 0) return;

// //     // 3️⃣ POST update
// //     const response = await fetch('/cart/update.js', {
// //       method: 'POST',
// //       headers: { 'Content-Type': 'application/json' },
// //       body: JSON.stringify({
// //         updates,
// //         sections: this.getSectionsToRender().map((s) => s.section),
// //         sections_url: window.location.pathname
// //       })
// //     });

// //     const data = await response.json();
// //     console.log('Cart updated:', data);

// //     publish(PUB_SUB_EVENTS.cartUpdate, {
// //       source: 'cart-items',
// //       cartData: data,
// //     });

// //   } catch (e) {
// //     console.error('Failed to remove bundle', e);
// //     const errors =
// //       document.getElementById('cart-errors') ||
// //       document.getElementById('CartDrawer-CartErrors');
// //     if (errors) errors.textContent = window.cartStrings.error;
// //   }
// // }

// async removeBundleByKey(bundleKey) {
//   try {
//     // 1️⃣ Fetch actual cart
//     const cart = await fetch('/cart.js').then(r => r.json());

//     // 2️⃣ Prepare updates using Shopify item keys
//     const updates = {};
//     cart.items.forEach((item) => {
//       if (item.properties?._bundle_link_key === bundleKey) {
//         updates[item.key] = 0;
//       }
//     });

//     if (Object.keys(updates).length === 0) return;

//     // 3️⃣ POST update
//     const response = await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         updates,
//         sections: this.getSectionsToRender().map((s) => s.section),
//         sections_url: window.location.pathname
//       })
//     });

//     const data = await response.json();
//     console.log('Cart updated:', data);

//     // 4️⃣ Publish update event
//     publish(PUB_SUB_EVENTS.cartUpdate, {
//       source: 'cart-items',
//       cartData: data,
//     });

//     // 5️⃣ Refresh cart drawer sections
//     this.getSectionsToRender().forEach((section) => {
//       const elementToReplace =
//         document.getElementById(section.id).querySelector(section.selector) ||
//         document.getElementById(section.id);

//       if (elementToReplace && data.sections?.[section.section]) {
//         elementToReplace.innerHTML = this.getSectionInnerHTML(
//           data.sections[section.section],
//           section.selector
//         );
//       }
//     });

//   } catch (e) {
//     console.error('Failed to remove bundle', e);
//     const errors =
//       document.getElementById('cart-errors') ||
//       document.getElementById('CartDrawer-CartErrors');
//     if (errors) errors.textContent = window.cartStrings.error;
//   }
// }


// async updateQuantity(line, quantity, name, variantId) {
//   this.enableLoading(line);

//   try {
//     const cart = await fetch('/cart.js').then(r => r.json());

//     let updates = {};

//     updates[line] = quantity;

//     // Remove any non-existing lines to prevent 422
//     Object.keys(updates).forEach(k => {
//       if (k < 1 || k > cart.items.length) delete updates[k];
//     });

//     if (Object.keys(updates).length === 0) {
//       console.warn('No valid line numbers to update');
//       return;
//     }

//     const parsedState = await response.json();

//     if (parsedState.status === 'fail' || parsedState.errors) {
//       this.updateLiveRegions(line, parsedState.message || parsedState.errors || 'Cart error');
//       return;
//     }

//     // Update DOM
//     this.getSectionsToRender().forEach((section) => {
//       const elementToReplace =
//         document.getElementById(section.id)?.querySelector(section.selector) ||
//         document.getElementById(section.id);

//       if (elementToReplace && parsedState.sections[section.section]) {
//         elementToReplace.innerHTML = this.getSectionInnerHTML(
//           parsedState.sections[section.section],
//           section.selector
//         );
//       }
//     });

//     this.updateLiveRegions(line, '');
//     publish(PUB_SUB_EVENTS.cartUpdate, {
//       source: 'cart-items',
//       cartData: parsedState,
//       variantId,
//     });

//   } catch (error) {
//     console.error(error);
//     const errors =
//       document.getElementById('cart-errors') ||
//       document.getElementById('CartDrawer-CartErrors');
//     if (errors) errors.textContent = window.cartStrings?.error || 'Cart error';
//   } finally {
//     this.disableLoading(line);
//   }
// }


//   // updateQuantity(line, quantity, name, variantId, bundleKeyFromDom) {
//   //   this.enableLoading(line);

//   //   const body = JSON.stringify({
//   //     line,
//   //     quantity,
//   //     sections: this.getSectionsToRender().map((section) => section.section),
//   //     sections_url: window.location.pathname,
//   //   });

//   //   fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
//   //     .then((response) => response.text())
//   //     fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
//   //   .then((response) => response.text())
//   //   .then((state) => {
//   //       const parsedState = JSON.parse(state);

//   //       // 🔥 Only run bundle removal if removing
//   //       if (quantity !== 0) return state;

//   //       const removedItem = parsedState.items[line - 1];
//   //       const bundleKey = bundleKeyFromDom || removedItem?.properties?._bundle_link_key;

//   //       if (!bundleKey) return state;

//   //       // Remove all items with same bundle key
//   //       const updates = {};
//   //       parsedState.items.forEach((item, index) => {
//   //         if (item.properties?._bundle_link_key === bundleKey) {
//   //           updates[index + 1] = 0;
//   //         }
//   //       });

//   //       return fetch(`${routes.cart_update_url}`, {
//   //         ...fetchConfig(),
//   //         body: JSON.stringify({
//   //           updates,
//   //           sections: this.getSectionsToRender().map((s) => s.section),
//   //           sections_url: window.location.pathname,
//   //         }),
//   //       }).then((r) => r.text());
//   //     })
//   //     .then((state) => {
//   //       const parsedState = JSON.parse(state);

//   //       const quantityElement =
//   //         document.getElementById(`Quantity-${line}`) ||
//   //         document.getElementById(`Drawer-quantity-${line}`);

//   //       const items = document.querySelectorAll('.cart-item');

//   //       if (parsedState.errors) {
//   //         quantityElement.value = quantityElement.getAttribute('value');
//   //         this.updateLiveRegions(line, parsedState.errors);
//   //         return;
//   //       }

//   //       this.classList.toggle('is-empty', parsedState.item_count === 0);

//   //       const cartDrawerWrapper = document.querySelector('cart-drawer');
//   //       const cartFooter = document.getElementById('main-cart-footer');

//   //       if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
//   //       if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

//   //       this.getSectionsToRender().forEach((section) => {
//   //         const elementToReplace =
//   //           document.getElementById(section.id).querySelector(section.selector) ||
//   //           document.getElementById(section.id);

//   //         elementToReplace.innerHTML = this.getSectionInnerHTML(
//   //           parsedState.sections[section.section],
//   //           section.selector
//   //         );
//   //       });

//   //       this.updateLiveRegions(line, '');

//   //       publish(PUB_SUB_EVENTS.cartUpdate, {
//   //         source: 'cart-items',
//   //         cartData: parsedState,
//   //         variantId: variantId,
//   //       });
//   //     })
//   //     .catch(() => {
//   //       const errors =
//   //         document.getElementById('cart-errors') ||
//   //         document.getElementById('CartDrawer-CartErrors');

//   //       errors.textContent = window.cartStrings.error;
//   //     })
//   //     .finally(() => {
//   //       this.disableLoading(line);
//   //     });
//   // }

// // ==================================================================
// // ==================================================================

//   updateLiveRegions(line, message) {
//     const lineItemError =
//       document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
//     if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

//     this.lineItemStatusElement.setAttribute('aria-hidden', true);

//     const cartStatus =
//       document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
//     cartStatus.setAttribute('aria-hidden', false);

//     setTimeout(() => {
//       cartStatus.setAttribute('aria-hidden', true);
//     }, 1000);
//   }

//   getSectionInnerHTML(html, selector) {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   enableLoading(line) {
//     const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
//     mainCartItems.classList.add('cart__items--disabled');

//     const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
//     const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

//     [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

//     document.activeElement.blur();
//     this.lineItemStatusElement.setAttribute('aria-hidden', false);
//   }

//   disableLoading(line) {
//     const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
//     mainCartItems.classList.remove('cart__items--disabled');

//     const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
//     const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

//     cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
//     cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
//   }
// }

// customElements.define('cart-items', CartItems);

// if (!customElements.get('cart-note')) {
//   customElements.define(
//     'cart-note',
//     class CartNote extends HTMLElement {
//       constructor() {
//         super();

//         this.addEventListener(
//           'change',
//           debounce((event) => {
//             const body = JSON.stringify({ note: event.target.value });
//             fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
//           }, ON_CHANGE_DEBOUNCE_TIMER)
//         );
//       }
//     }
//   );
// }



class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItem = this.closest('.cart-item');
      const bundleKeyFromDom = cartItem?.dataset?.bundleKey;

      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');

      if (bundleKeyFromDom) {
        cartItems.removeBundleByKey(bundleKeyFromDom);
      } else {
        // Normal single item remove
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      this.refreshEntireCartDrawer();
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const sections = [];
    
    // Main cart items (cart page)
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }
    
    // Cart icon bubble
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      });
    }
    
    // Cart live region
    const cartLiveRegion = document.getElementById('cart-live-region-text');
    if (cartLiveRegion) {
      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      });
    }
    
    // Main cart footer (cart page)
    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }
    
    return sections;
  }

  async removeBundleByKey(bundleKey) {
    try {
      // Show loading
      this.enableLoading(0);

      // Fetch current cart
      const cart = await fetch('/cart.js').then((r) => r.json());

      // Prepare updates
      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties?._bundle_link_key === bundleKey) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        this.disableLoading(0);
        return;
      }

      // Update cart
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (data.status === 'fail' || data.errors) {
        throw new Error(data.message || data.errors || 'Cart error');
      }

      // Update UI
      await this.updateUIAfterChange(data);

      // Publish event
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        cartData: data,
      });
    } catch (error) {
      console.error('Failed to remove bundle:', error);
      this.showError(error.message || 'Failed to remove bundle');
    } finally {
      this.disableLoading(0);
    }
  }

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (data.status === 'fail' || data.errors) {
        throw new Error(data.message || data.errors || 'Cart error');
      }

      // Update UI
      await this.updateUIAfterChange(data);

      this.updateLiveRegions(line, '');

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        cartData: data,
        variantId,
      });
    } catch (error) {
      console.error('Error updating quantity:', error);
      this.showError(error.message || 'Failed to update quantity');
      
      // Reset quantity input on error
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      if (quantityElement) {
        quantityElement.value = quantityElement.getAttribute('value');
      }
    } finally {
      this.disableLoading(line);
    }
  }

  async updateUIAfterChange(data) {
    const isEmpty = data.item_count === 0;
    
    console.log('Cart update data:', data);
    console.log('Is cart empty?', isEmpty);

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      // For cart drawer - refresh entire section
      await this.refreshEntireCartDrawer();
      
      // Update empty state
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', isEmpty);
        
        // Force update empty message if needed
        if (isEmpty) {
          this.ensureEmptyMessageInDrawer();
        }
      }
    } else {
      // For cart page
      this.classList.toggle('is-empty', isEmpty);
      
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', isEmpty);
      }

      // Update sections if data has sections
      if (data.sections && Object.keys(data.sections).length > 0) {
        this.updateSections(data);
      }
    }
  }

  async refreshEntireCartDrawer() {
    try {
      console.log('Refreshing entire cart drawer...');
      
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const text = await response.text();
      console.log('Cart drawer response received');
      
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      // Get all cart drawer related elements
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      if (!cartDrawerWrapper) {
        console.error('Cart drawer wrapper not found');
        return;
      }
      
      // Get the new cart drawer HTML
      const newCartDrawer = html.querySelector('cart-drawer');
      if (!newCartDrawer) {
        console.error('New cart drawer not found in response');
        return;
      }
      
      // Replace the entire cart drawer content (but keep the wrapper element)
      cartDrawerWrapper.innerHTML = newCartDrawer.innerHTML;
      
      console.log('Cart drawer refreshed successfully');
      
      // Reinitialize any custom elements inside
      this.reinitializeCartDrawerElements();
      
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      this.showError('Could not update cart. Please try again.');
    }
  }

  reinitializeCartDrawerElements() {
    // Reinitialize cart items if needed
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && !cartDrawerItems.isConnected) {
      document.querySelector('cart-drawer').appendChild(cartDrawerItems);
    }
    
    // Reinitialize any buttons or interactive elements
    const removeButtons = document.querySelectorAll('cart-remove-button');
    removeButtons.forEach(button => {
      if (!button.isConnected) {
        // Reattach event listeners if needed
        const newButton = new CartRemoveButton();
        button.parentNode.replaceChild(newButton, button);
      }
    });
  }

  ensureEmptyMessageInDrawer() {
    // Check if empty message exists
    const emptyMessage = document.querySelector('.cart__empty-text, .cart-drawer__empty, [data-cart-empty-message]');
    
    if (!emptyMessage) {
      console.log('No empty message found, creating one...');
      
      // Create default empty message
      const cartDrawerContent = document.querySelector('.cart-drawer__content') || 
                                 document.querySelector('.cart-drawer__inner') ||
                                 document.querySelector('cart-drawer');
      
      if (cartDrawerContent) {
        const emptyDiv = document.createElement('div');
        emptyDiv.className = 'cart-drawer__empty text-center';
        emptyDiv.innerHTML = `
          <div class="cart-empty-message">
            <h2 class="h4">Your cart is empty</h2>
            <p>Continue shopping to add items to your cart.</p>
            <a href="/" class="button button--primary">Continue Shopping</a>
          </div>
        `;
        
        // Find where to insert it
        const cartItemsContainer = cartDrawerContent.querySelector('cart-drawer-items') || 
                                   cartDrawerContent.querySelector('.cart-drawer__items');
        
        if (cartItemsContainer) {
          cartItemsContainer.innerHTML = '';
          cartItemsContainer.appendChild(emptyDiv);
        } else {
          // Append to cart drawer content
          cartDrawerContent.appendChild(emptyDiv);
        }
      }
    }
  }

  updateSections(data) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);

      if (elementToReplace && data.sections?.[section.section]) {
        const newContent = this.getSectionInnerHTML(
          data.sections[section.section],
          section.selector
        );
        
        if (newContent) {
          elementToReplace.innerHTML = newContent;
        }
      }
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.innerHTML = message;
        lineItemError.style.display = message ? 'block' : 'none';
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    
    if (cartStatus) {
      if (message) {
        cartStatus.innerHTML = message;
      }
      cartStatus.setAttribute('aria-hidden', false);
      
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    try {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const element = parsedHtml.querySelector(selector);
      return element ? element.innerHTML : html;
    } catch (error) {
      console.error('Error parsing HTML:', error);
      return html;
    }
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    // Show loading overlay for all items if bundle removal (line = 0)
    if (line === 0) {
      // Show loading on all cart items for bundle removal
      const allLoadingOverlays = document.querySelectorAll('.loading-overlay');
      allLoadingOverlays.forEach((overlay) => overlay.classList.remove('hidden'));
    } else {
      // Show loading only for specific line
      const cartItemElements = document.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
        overlay.classList.remove('hidden')
      );
    }

    document.activeElement?.blur();
    
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    // Hide all loading overlays
    const allLoadingOverlays = document.querySelectorAll('.loading-overlay');
    allLoadingOverlays.forEach((overlay) => overlay.classList.add('hidden'));

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
  }

  showError(message) {
    const errors =
      document.getElementById('cart-errors') ||
      document.getElementById('CartDrawer-CartErrors');
    
    if (errors) {
      errors.textContent = message || window.cartStrings?.error || 'Cart error';
      errors.style.display = 'block';
      
      // Auto hide error after 5 seconds
      setTimeout(() => {
        errors.style.display = 'none';
      }, 5000);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Helper function to check if cart drawer is open
function isCartDrawerOpen() {
  const cartDrawer = document.querySelector('cart-drawer');
  return cartDrawer && cartDrawer.hasAttribute('open');
}